<template>
  <v-alert class="mb-4 bordered" :value="true" color="warning">
    <v-row>
      <v-col sm12 md8>
        <h4 class="text-h4 mb-2">{{ $t('title') }}</h4>
        <p class="subheading">{{ $t('body') }}</p>
      </v-col>
      <v-col align-self-end sm12 md4 class="text-sm-left text-md-right">
        <v-btn class="ml-0 mr-2" color="warning darken-3" large depressed :loading="verifying" @click="verify()">{{
          $t('verify')
        }}</v-btn>
        <v-btn class="mx-0" color="warning darken-3" large depressed :loading="sending" @click="resend()">{{
          $t('resendLinks')
        }}</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import VerifyMixin from './VerifyMixin'

export default {
  name: 'AccountPending',
  mixins: [VerifyMixin]
}
</script>

<i18n>
{
  "en": {
    "body": "Please check your emails and text notifications and click on the verification links to validate and activate your account. If you have not received the verification messages we can send them to you again.",
    "resendLinks": "@:labels.resendLinks",
    "title": "Your account is pending verification",
    "verify": "@:labels.verify"
  },
  "fr": {
    "body": "Veuillez vérifier vos courriels et notifications textes et cliquer sur les liens de vérifications afin de les valider et activer votre compte. Si vous n'avez pas reçus les messages de vérifications nous pouvons vous les envoyer à nouveau.",
    "resendLinks": "@:labels.resendLinks",
    "title": "Votre compte est en attente de vérification",
    "verify": "@:labels.verify"
  }
}
</i18n>
